import { KeywordDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export const hasMaterialSelection = (
  articleId?: string,
  keywords?: KeywordDto[],
) =>
  Boolean(
    articleId?.trim() ||
      keywords?.some((keyword) => keyword.originalKeyword?.trim()),
  )
